import { state } from './types';

export default {
  [state.IS_COLLECTION]: false,
  [state.DATASET]: null,
  [state.COLLECTION]: null,
  [state.SUBJECTS]: [],
  [state.VARIABLES]: [],
  [state.SUBJECT_VARIABLES]: [],
  [state.OBSERVATION_VARIABLES]: [],
  [state.SELECTED_VARIABLES]: [],
  [state.VARIABLE_DATA]: {},
  [state.FIRST_VISITS]: {},
  [state.LAST_VISITS]: {},
  [state.VISIT_VARIABLE]: 'Visit Event',
  [state.VISIT_SUMMARIES]: null,
  [state.TIMES_BETWEEN_VISITS]: [],
  [state.TIMES_BETWEEN_VISITS_REQUEST_NUM]: 0,
  [state.TIMES_BETWEEN_VISITS_REQUEST_DELAY_SECS]: 0.5,
  [state.NUM_SELECTED_SUBJECTS]: 0,
  [state.USE_LONG_SCALE_NAMES]: false,
  [state.ENABLE_VARIABLE_SELECTION]: false,
};
